import {
  openPopupPromise,
  PopupDialogOrigin,
} from 'src/lib/popups/popupOpenClose';
import { CatalogItem } from 'src/replicant/catalog/catalog.ruleset';
import StateObserver from 'src/StateObserver';
import { getTutorialController } from '../tutorial/TutorialController';
import { getCatalogItems } from './helpers';

/**
 * Show main catalog items popup
 */
export async function openCatalogPopup(origin: PopupDialogOrigin | undefined) {
  await getTutorialController().handleEvent('catalogOpen');

  const items = getCatalogItems();
  await openPopupPromise('popupCatalogList', { items, origin });
}

/**
 * Sell an item.
 * @param itemId
 * @param tier
 */
export async function sellCatalogItem(item: CatalogItem) {
  const confirmed = await openPopupPromise('popupCatalogItemSell', item);

  if (confirmed) {
    await StateObserver.invoke.sellCatalogItem(item);
  }

  return confirmed;
}
